

exports.__esModule = true;

var _squid = require('squid');

var _index = require('xo-device-info/dist/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _auth = require('xo-models/src/auth');

var _index2 = require('components/xo-models/src/checkout/index');

var _index3 = require('components/xo-models/src/credit/index');

var _model = require('components/xo-tracking/dist/model');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoRedirectToCapeDirective', {
    tag: 'xo-redirect-to-cape',
    template: _template2['default'],
    props: { token: { type: 'var', required: true } },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.creditDataModel = _index3.$CreditDataModel.instance(this.props.token);
            var url = 'https://' + window.location.host + _squid.$config.urls.baseUrl;
            var returnUrl = _squid.$util.buildURL(url, { token: this.props.token });
            var transactionType = this.models.checkoutAppData.is_second_button_txn ? 'SECOND_BUTTON' : 'HERMES';
            var isSignupFlow = this.models.auth.logged_in ? 'false' : 'true';

            var capeData = {
                'flow_attributes': {
                    'channel': _index.$DeviceInfo.isMobile() ? 'MOBILE' : 'WEB',
                    'flow': 'CHECKOUT_CREDIT_BUTTON',
                    'primary_actor': 'PAYPAL',
                    'tracking_id': this.props.token,
                    'business_case_variation': transactionType
                },
                'locale': _squid.$locale.lang + '_' + _squid.$locale.country,
                'cart_id': this.props.token,
                'fraudnet_id': this.props.token,
                'context-type': 'Full-context',
                'cal_correlation_id': _model.$CalDataModel.getCalCorrId(),
                'return_uris': {
                    'normal_return_uri': returnUrl + '&success=true',
                    'system_error_uri': returnUrl + '&success=false&isInternalServiceError=true',
                    'return_to_login_uri': returnUrl,
                    'full_pay_uri': this.models.auth.logged_in ? returnUrl + '&success=false' : undefined,
                    'cancel_uri': this.models.checkoutAppData.urls.cancel_url,
                    'change_installments_uri': returnUrl + '&changeStatus=changeInstallment&creditSignup=' + isSignupFlow
                }
            };
            var data = {
                creditData: capeData,
                newUserSignup: isSignupFlow
            };

            return this.creditDataModel.action('createCreditKey', {
                data: data,
                success: function success(res) {
                    var capeUrl = (0, _squid.$feature)('capeUrl') + res.capeKey + '&token=' + _this.props.token;
                    if (_this.creditDataModel.isChangeStatus()) {
                        capeUrl += '&status=changeInstallment';
                    }
                    _this.creditDataModel.setCapeRedirectUri(capeUrl);
                    _squid.$util.redirect(capeUrl);
                }
            });
        }
    }
});


_squid.$Component;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$feature;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index3.$CreditDataModel;

_model.$CalDataModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/redirect-to-cape/directive.js
// module id = ./components/xo-credit-components/src/redirect-to-cape/directive.js
// module chunks = 1